$(function() {
  
  

$( ".custom-colorx a" ).hover(
  function() {
   $(this).addClass("active"); 
  }, function() {
   $(this).removeClass("active");
  }
);
  
    $(function() {
        $('.beefup').beefup();
    });
  
  $(".ctab").click(function(){
$(".ctab").removeClass("active");
$(this).addClass("active");
var pp=$(this).attr("data-action");
$(".pctab").hide();
$("."+pp).show();
})
  
  $(".bolt2").click(function(){
$(".hli").toggleClass("active");
})
  
  $(".dropdow-mb").click(); 
  
  
  $(".collection-template .atc").click();


  
   $(".collection-template .atc").click();
  
  
  $(".prdblktop .atc").click();
  
  
  
  
  
  
$(".custom-color a").on({
    mouseenter: function () {
        //stuff to do on mouse enter
$(this).find("span").show();
    },
    mouseleave: function () {
        //stuff to do on mouse leave
$(this).find("span").hide();
    }
});


var swiper = new Swiper(".bslider", {
   slidesPerView: 1,
        spaceBetween: 0,
  centeredSlides:true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
  
  var swiper4 = new Swiper(".myxSwiper", {
   slidesPerView: 1,
        spaceBetween: 0,
  centeredSlides:true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
  
  
  
  
  
  var swiper1 = new Swiper(".mySwiper", {
    slidesPerView: 5,
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: true,
        },
      });



 
 
});




 
 

